export * from './map.js';
export * from './facade.js';
export * from './mapEdit.js';
export { MAP_EDITS } from './mapEdits.generated.js';
export * from './animContract.js';

/** Server→client snapshot rate (Hz). Sim runs faster (see sim TICK_HZ). */
export const SNAPSHOT_HZ = 20;

/** Faction / team identifiers (kept stable; part of the wire protocol). */
export const Team = {
  Fisura: 0,
  Policia: 1,
} as const;
export type TeamId = (typeof Team)[keyof typeof Team];

/** Faction colours (RGB 0..1) — shared so kill feed, characters, HUD agree. */
export const TEAM_COLOR: Record<number, [number, number, number]> = {
  [Team.Fisura]: [0.95, 0.42, 0.12],
  [Team.Policia]: [0.25, 0.4, 0.95],
};

/** Default game server port for local development. */
export const DEFAULT_SERVER_PORT = 8080;
